module.exports = __webpack_public_path__ + "Step6_Header_new.067a206e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/2018/mobile/headers/Step6_Header_new.png
// module id = rU6T
// module chunks = 0